import * as React from 'react'
import { render } from 'react-dom'
import App from './components/App'
import store, { history } from './store'
import { Provider, ReactReduxContextValue } from 'react-redux'
import { ConfigProvider } from 'antd'
import { ConnectedRouter } from 'connected-react-router'
import { History, LocationState } from 'history'
ConfigProvider.config({ theme: { primaryColor: _theme.colors.primary } })

declare module 'connected-react-router' {
  export interface ConnectedRouterProps<S = LocationState> {
    history: History<S>
    context?: React.Context<ReactReduxContextValue>
    noInitialPop?: boolean
    noTimeTravelDebugging?: boolean
    omitRouter?: boolean
    children?: JSX.Element
  }
}

render(
  <ConfigProvider>
    <Provider store={store}>
      <ConnectedRouter history={history}>
        <App />
      </ConnectedRouter>
    </Provider>
  </ConfigProvider>,
  document.getElementById('root')
)
